import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useTranslation } from '@stepstone-platform/i18n';
import { useEffect } from 'react';
import { Input } from '../../../../components/common/Input/index.js';
import { emailSelector, updateEmail, updateEmailError, updateEmailErrorMessage, } from '../../registrationSlice.js';
import { validateEmail } from '../../../../helpers/validateEmail.js';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux/index.js';
import { twoStepActiveStateSelector, updateTwoStepActiveState, } from '../../../TwoStepLoginRegistration/twoStepLoginRegistrationSlice.js';
import { accountIdentifierEmailSelector, updateAccountIdentifierEmail, } from '../../../TwoStepLoginRegistration/views/AccountIdentifier/accountIdentifierSlice.js';
export const RegistrationEmailInput = () => {
    const { t } = useTranslation();
    const emailState = useAppSelector(emailSelector);
    const accountIdentifierEmail = useAppSelector(accountIdentifierEmailSelector);
    const twoStateForm = useAppSelector(twoStepActiveStateSelector);
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (twoStateForm === 'registration') {
            dispatch(updateEmail(accountIdentifierEmail.value));
        }
    }, []);
    const onBlurEmail = ({ target: { value } }, isTouched) => {
        if (isTouched) {
            const hasError = !validateEmail(value);
            dispatch(updateEmailError(hasError));
            if (hasError) {
                dispatch(updateEmailErrorMessage(t('loginregistration.email.validation.error')));
            }
        }
    };
    const emailOnChange = ({ target: { value }, }) => {
        if (twoStateForm === 'registration') {
            dispatch(updateAccountIdentifierEmail(value));
            dispatch(updateTwoStepActiveState('accountIdentifier'));
        }
        dispatch(updateEmail(value));
    };
    const { value, error, errorMessage } = emailState;
    return (_jsx(Input, { dataTestId: "email-input", value: value, onChange: emailOnChange, type: 'email', name: 'email', formLabel: t('loginregistration.registration.email.headerInput'), placeholder: t('loginregistration.registration.email.placeholder'), hasError: error, errorText: errorMessage, onBlur: onBlurEmail, autoComplete: 'email' }));
};
//# sourceMappingURL=RegistrationEmailInput.js.map